<template>
    <div class="index">
        <div class="top">
            <el-steps :active="stepsActive" simple finish-status="process" process-status="finish" style="width:800px">
                <el-step title="新案件" :icon="stepsActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘中" :icon="stepsActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘审核" :icon="stepsActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘退回" :icon="stepsActive>3?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘完成" :icon="stepsActive>4?'el-icon-folder-checked':'el-icon-edit'"></el-step>
            </el-steps>
            <div>
                <el-button type="primary" icon="el-icon-edit-outline" v-if="stepsActive==0" @click="receiveCase">接受</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" v-if="stepsActive==1||stepsActive==3" @click="submitCase()">保存</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" v-if="stepsActive==1||stepsActive==3" @click="submitAudit()">提交审核</el-button>
                <!-- <el-button type="warning" icon="el-icon-edit-outline" @click="addRemark">添加备注日志</el-button> -->
            </div>
        </div>
        <div class="taskreason" v-if="stepsActive==3&&humanData.dcReturnReason">
            <span>*</span>
            审核退回原因： 
            {{humanData.dcReturnReason}}
        </div>
        <div class="index-item">
            <div class="title">
                案件信息
            </div>
            <div class="content">
                <div class="citem">
                    <div class="label">
                        委托主体
                    </div>
                    <el-input v-model="detailData.wtzt" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>
                <div class="citem">
                    <div class="label">
                        委托时间
                    </div>
                    <el-input v-model="detailData.creationTime" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>
                <div class="citem">
                    <div class="label">
                        报案号
                    </div>
                    <el-input v-model="detailData.caseNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        案件类型
                    </div>
                    <el-input v-model="detailData.caseTypeStr" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>
                
                <div class="citem">
                    <div class="label">
                        案发地区
                    </div>
                    <el-cascader
                        size="small"
                        :options="options"
                        v-model="crimeCityCode"
                        @change="handleRegionChange">
                    </el-cascader>
                    <!-- <el-input v-model="detailData.zhengJianNo" placeholder="请输入" size="small" class="citem-input"></el-input> -->
                </div>
                <div class="citem">
                    <div class="label">
                        案发地点
                    </div>
                    <el-input v-model="detailData.address" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        联系人
                    </div>
                    <el-input v-model="detailData.contacts" placeholder="" size="small" class="citem-input"></el-input>
                </div>
                <div class="citem">
                    <div class="label">
                        联系人电话
                    </div>
                    <el-input v-model="detailData.contactsPhone" placeholder="" size="small" class="citem-input"></el-input>
                </div>
                <div class="citem">
                    <div class="label">
                        联系人地址
                    </div>
                    <el-input v-model="detailData.contactsAddress" placeholder="" size="small" class="citem-input"></el-input>
                </div>


                <div class="citem">
                    <div class="label">
                        标的责任
                    </div>
                    <el-input v-model="detailData.targetLand" placeholder="请输入" size="small" class="citem-input"></el-input>
                    
                </div>
                <div class="citem">
                    <div class="label">
                        标准公估费
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.fee" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                </div>

                <div class="citem">
                    <div class="label">
                        实收公估费
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.ssFee" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        总作业费
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.operatorFees" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        主案件状态
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.piccStatusStr" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        财务状态
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.financialStatusStr" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        作业费
                    </div>
                    <el-input v-model="humanData.operatorFee" placeholder="请输入" size="small" class="citem-input"></el-input>
                    
                </div>
                <div class="citem">
                    <div class="label">
                        车牌号
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.carNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        车险查勘员
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.survey" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        查勘员手机号
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.surveyPhone" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                
                <div class="citem citem-textarea" style="width:100%">
                    <div class="label">
                        派工备注:
                    </div>
                    <div class="value" style="width:778px">{{detailData.remark?detailData.remark:'暂无'}}</div>
                </div>
                <div class="citem citem-textarea" style="width:100%">
                    <div class="label">
                        查勘备注:
                    </div>
                    <div class="value" style="width:778px">{{detailData.tip?detailData.tip:'暂无'}}</div>
                </div>
                <div class="citem citem-textarea" style="width:100%">
                    <div class="label">
                        未决备注:
                    </div>
                    <div class="value" style="width:778px">{{detailData.wjtip?detailData.wjtip:'暂无'}}</div>
                </div>
                <div class="citem citem-textarea" style="width:100%">
                    <div class="label">
                        调查需求:
                    </div>
                    <div class="value" style="width:778px">{{humanData.dcYq?humanData.dcYq:'暂无'}}</div>
                    
                    <!-- <el-input v-model="detailData.remark" placeholder="请输入" size="small" class="citem-input" rows="4" type="textarea" style="width:778px"></el-input> -->
                </div>
            </div>
        </div>
        
         <!-- @tab-click="tabSelect" -->
        <el-tabs type="border-card" class="card" v-model="tabsValue" @tab-click="selectTab">
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 伤者信息</span>
                <div class="content">
                    <div class="citem">
                        <div class="label">
                            伤者姓名
                        </div>
                        <el-input v-model="humanData.name" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            联系电话
                        </div>
                        <el-input v-model="humanData.phone" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            联系地址
                        </div>
                        <el-input v-model="humanData.contactAddress" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            证件类型
                        </div>
                        <el-input v-model="humanData.idType" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            证件号码
                        </div>
                        <el-input v-model="humanData.idNumber" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            归属车辆
                        </div>
                        <el-input v-model="humanData.guiShuCar" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>

                    <div class="citem">
                        <div class="label">
                            伤者身份
                        </div>
                        <el-input v-model="humanData.humanShenFen" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            伤者类型
                        </div>
                        <el-input v-model="humanData.humanType" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            职业类型
                        </div>
                        <el-input v-model="humanData.zhiYeType" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            所在行业
                        </div>
                        <el-input v-model="humanData.hangYe" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            收入(元/日)
                        </div>
                        <el-input v-model="humanData.shouRu" placeholder="请输入" size="small" class="citem-input" type="number"></el-input>
                    </div>
                    <div class="citem">
                        <div class="label">
                            工作单位
                        </div>
                        <el-input v-model="humanData.danWei" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                    <div class="citem" style="width:100%">
                        <div class="label">
                            备注
                        </div>
                        <el-input v-model="humanData.remark" placeholder="请输入" size="small" class="citem-input" type="textarea" style="width:500px"></el-input>
                    </div>


                    
                </div>
                
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 影像资料</span>
                <div class="btns">
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="materialUpload"
                        v-if="stepsActive==1||stepsActive==3"
                        >
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="materialUpload" style="margin-right:10px">新增资料</el-button>
                    </el-upload>
                    <!-- <el-button type="success" icon="el-icon-download" @click="materialDownload">本地下载</el-button> -->
                    <el-button type="success" icon="el-icon-download" @click="downloadMaterial">下载资料</el-button>
                </div>
                <div class="materiallist">
                    <div class="material" v-for="(item,index) in materialList" :key="index">
                        <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                        <el-image
                        style="width: 120px; height: 120px"
                        :src="item.path"
                        v-else-if="item.fileType=='jpg'||item.fileType=='png'||item.fileType=='gif'||item.fileType=='jpeg'"
                        @click="showImg(item.path,materialList)"
                        :fit="cover"></el-image>
                        <img src="../../../assets/images/icon13.png" alt="" v-else @click="download(item.path,item.name)">


                        <img src="../../../assets/images/icon08.png" class="close" @click="clearMaterialList(index)" alt="" v-if="stepsActive==1||stepsActive==3">
                        <div class="filename">{{item.name}}</div>
                    </div>
                </div>
            </el-tab-pane>
            
            <!-- <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i>医院信息</span>
                <div class="btns" v-if="stepsActive==1">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="hospitalAddDialog = true">新增医院信息</el-button>
                </div>
                <el-table
                    :data="hospitalList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="80"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="医院名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="keShi"
                    label="科室"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="ruHospitalTime"
                    label="入院时间"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="chuHospitalTime"
                    label="出院时间"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="yjZhuHospitalTime"
                    label="预计住院时间"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="150px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateHospitalDialogShow(scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteHospitalTip(scope.row)">删除</el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 诊断信息</span>
                <div class="btns" v-if="stepsActive==1">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="diagnoseDialog = true">新增诊断信息</el-button>
                </div>
                <el-table
                    :data="diagnoseList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="80"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="jws"
                    label="既往史"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="ssbw"
                    label="损失部位"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="lczd"
                    label="临床诊断"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="ssms"
                    label="损失描述"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="zsfs"
                    label="治疗方式"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="150px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateHospitalDialogShow(scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteHospitalTip(scope.row)">删除</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 定损明细</span>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="lossAddDialog = true">新增定损</el-button>
                </div>
                <el-table
                    :data="lossList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="80"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="feeName"
                    label="费用名称"
                    align="center"
                    >
                    </el-table-column>
                    
                    <el-table-column
                    prop="spFee"
                    label="索赔金额"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="dsFee"
                    label="定损金额"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="hsFee"
                    label="核损金额"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="150px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateHospitalDialogShow(scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteHospitalTip(scope.row)">删除</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="content">
                    <div class="citem" style="margin-top:20px;width:800px">
                        <div class="label">
                            定损备注:
                        </div>
                        <div class="value">
                            <el-input v-model="humanData.shouRu" placeholder="请输入" size="small" class="citem-input" type="textarea" style="width:500px"></el-input>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="section">
                        <div class="title">
                            垫付费用
                        </div>
                         <div class="item">
                            <div class="label">
                                标的客户：
                            </div>
                            <div class="value">
                                <el-input v-model="humanData.cClmNo" placeholder="请输入" size="small" class="citem-input" ></el-input>
                            </div>
                        </div>

                        <div class="item">
                            <div class="label">
                                三者客户：
                            </div>
                            <div class="value">
                                <el-input v-model="humanData.cDoubtId" placeholder="请输入" size="small" ></el-input>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 派工信息</span>
                <div class="content">
                    <div class="citem">
                        <div class="label">
                            指派查勘员:
                        </div>
                        <div class="value">
                            <el-select v-model="humanData.operatorId" size="small" placeholder="请选择"  class="citem-input" @change="changeOperatorId">
                                <el-option
                                v-for="item in personList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="citem">
                        <div class="label">
                            指派调解员:
                        </div>
                        <div class="value">
                            <el-select v-model="humanData.tjyId" size="small" placeholder="请选择"  class="citem-input" @change="changeTjyId">
                                <el-option
                                v-for="item in personList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="citem" style="width:100%">
                        <div class="label">
                            查勘需求:
                        </div>
                        <div class="value">
                            <el-input v-model="humanData.dcYq" placeholder="请输入" size="small" class="citem-input" type="textarea" style="width:500px"></el-input>
                        </div>
                    </div>
                </div>
            </el-tab-pane> -->
        </el-tabs>



        

        <div class="bottom" v-if="stepsActive==1||stepsActive==3">
            <el-button type="primary" icon="el-icon-edit" @click="submitCase()">保存</el-button>
            <el-button type="primary" icon="el-icon-edit-outline" v-if="stepsActive==1||stepsActive==3" @click="submitAudit()">提交审核</el-button>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="hospitalAddDialog" title="新增医院信息" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        医院名称：
                    </div>
                    <div class="value">
                        <el-input v-model="hospitalData.name" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        科室：
                    </div>
                    <div class="value">
                        <el-input v-model="hospitalData.keShi" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        入院时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                            v-model="hospitalData.ruHospitalTime"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        出院时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                            v-model="hospitalData.chuHospitalTime"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        预计住院时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                            v-model="hospitalData.yjZhuHospitalTime"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                
                <div class="dialog-footer">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addHospital">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="diagnoseDialog" title="新增诊断信息" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        既往史:
                    </div>
                    <div class="value">
                        <el-input v-model="diagnoseData.jws" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        损失部位：
                    </div>
                    <div class="value">
                        <el-input v-model="diagnoseData.ssbw" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        临床诊断:
                    </div>
                    <div class="value">
                        <el-input v-model="diagnoseData.lczd" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        损失描述:
                    </div>
                    <div class="value">
                        <el-input v-model="diagnoseData.ssms" placeholder="请输入" size="small"></el-input>
                        
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        治疗方式:
                    </div>
                    <div class="value">
                        <el-input v-model="diagnoseData.zsfs" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                
                <div class="dialog-footer">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addDiagnose">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="lossAddDialog" title="新增定损明细" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        费用名称:
                    </div>
                    <div class="value">
                        <el-input v-model="lossData.feeName" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        索赔金额:
                    </div>
                    <div class="value">
                        <el-input v-model="lossData.spFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        定损金额:
                    </div>
                    <div class="value">
                        <el-input v-model="lossData.dsFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        核损金额:
                    </div>
                    <div class="value">
                        <el-input v-model="lossData.hsFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                
                
                <div class="dialog-footer">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addLoss">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeD} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { regionDataPlus , provinceAndCityData , CodeToText , TextToCode } from "element-china-area-data";
import {CaseTypeList } from '../../../assets/selectList/index'
import { batchDownload } from "../../../utils/downZip";
import store from '../../../store'

export default {
    name: 'index',
    components:{
        ElImageViewer
    },
    
    data () {
        return {
            caseTypeList:CaseTypeList,
            detailData:{
                
            },
            humanData:{
                "piccHumanTaskId": null,
                "piccHumanId": null,
                "name": "",
                "phone": "",
                "contactAddress": "",
                "idType": "",
                "idNumber": "",
                "humanType": "",
                "humanShenFen": "",
                "zhiYeType": "",
                "hangYe": "",
                "shouRu": 0,
                "danWei": "",
                "guiShuCar": "",
                "dianFuFee": 0,
                "dispatchId": null,
                "tjReturnReason": "",
                "dcReturnReason": ""
            },

            options:provinceAndCityData,
            crimeCityCode:[],
            uploadUrl:'',

           


            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            allNum:0,
            finishNum:0,

            stepsActive:'',
            tabsValue:'0',

            materialList:[],
            hospitalList:[],
            diagnoseList:[],

            crimeCityCode:[],

            hospitalData:{},
            hospitalAddDialog:false,

            diagnoseList:[],
            diagnoseData:{},
            diagnoseDialog:false,

            lossList:[],
            lossData:{},
            lossAddDialog:false,

            personList:[],

            uploadImgList:[],
            uploadImgNum:0,
        }
    },
    computed: {
        isUploadImgEnd() {
            return this.$store.state.global.isUploadImgEnd;
        }
    },
    
    watch:{
        "isUploadImgEnd":function(ov,nv){
            let _this = this;
            store.dispatch('global/setLoading', true);
            this.uploadImgNum = this.uploadImgNum + 1;
            if(this.uploadImgList.length == this.uploadImgNum){
                setTimeout(function(){
                    store.dispatch('global/setLoading', false);
                    _this.materialList = _this.materialList.concat(_this.uploadImgList)
                    _this.uploadImgList = [];
                    _this.uploadImgNum = 1;
                },1000)
            }

        },
        'tabsValue':function(n,o){
            if(this.stepsActive!=1&&this.stepsActive!=3){
                return;
            }
            if(o==0){
                if(this.humanData.id){
                    this.updateHuman();
                }else{
                    this.addHuman();
                }
            }else if(o==1){
                this.saveDcTaskMaterials();
            }else if(o==2){
            }else if(o==4){
                // this.assignHuman();
            }
            
        }
    },
    created(){
        

    },
    mounted(){
        this.getDetailData();
        this.queryHumanDetail();
        this.queryUserByMechanismIds();
    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        handleRegionChange(codeArray){
            if(codeArray[0]){
                this.detailData.province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.detailData.city = CodeToText[codeArray[1]]
            }
        },
        // 查询机构人员
        async queryUserByMechanismIds(){
            let res = await api.queryUserByMechanismIds({
                pageSize:1000,
            });
            this.personList = res.data.data;
        },
        // 新增伤者信息
        async addHuman(){
            this.humanData.piccHumanId = this.$route.query.id;
            this.humanData.shouRu = parseFloat(this.humanData.shouRu?this.humanData.shouRu:0);
            let res = await api.addHuman({humans:[this.humanData]});
            // this.humanData.id = res.data.data.humanId
            if(res.data.code=='200'){
                this.$router.go(-1)
            }
            return true;
        },
        
        // 更新伤者信息
        async updateHuman(){
            this.humanData.piccHumanId = this.$route.query.id;
            this.humanData.shouRu = parseFloat(this.humanData.shouRu?this.humanData.shouRu:0);
            let res = await api.updateHuman(this.humanData);
            return true;
        },
        

        // 保存查勘資料
        async saveDcTaskMaterials(){
            if(this.materialList.length==0){
                return;
            }
            for(let index in this.materialList){
                this.materialList[index].sort = parseFloat(index);
            }
            let res = await api.addDcTaskMaterials({dcTaskMaterials:this.materialList});
        },
        async queryDcTaskMaterialByHumanId(){
            let res = await api.queryDcTaskMaterialByHumanId(this.$route.query.humanId);
            this.materialList = res.data.data;
        },
       
        
        // 查看详情
        async getDetailData(){
            let res = await api.piccHumanQueryByPiccHumanId(this.$route.query.id);
            this.detailData = res.data.data;
            this.detailData.caseTypeStr = this.detailData.caseType==1?'全流程':'首勘';
            if(this.detailData.piccStatus==1){
                this.detailData.piccStatusStr='案件未完成'
            }
            else if(this.detailData.piccStatus==2){
                this.detailData.piccStatusStr='已核损待结案'
            }
            else if(this.detailData.piccStatus==3){
                this.detailData.piccStatusStr='已结案'
            }
            if(this.detailData.financialStatus==0){
                this.detailData.financialStatusStr='无'
            }
            else if(this.detailData.financialStatus==1){
                this.detailData.financialStatusStr='已开票未回款'
            }
            else if(this.detailData.financialStatus==2){
                this.detailData.financialStatusStr='已开票部分回款'
            }
            else if(this.detailData.financialStatus==3){
                this.detailData.financialStatusStr='回款完成'
            }
            else if(this.detailData.financialStatus==4){
                this.detailData.financialStatusStr='已回款未开票'
            }
            else if(this.detailData.financialStatus==5){
                this.detailData.financialStatusStr='其他'
            }
            if(TextToCode[this.detailData.province]&&TextToCode[this.detailData.province][this.detailData.city]){
                this.crimeCityCode = [TextToCode[this.detailData.province].code,TextToCode[this.detailData.province][this.detailData.city].code];
            }
            
        },
        // 根据伤者Id查看详情
        async queryHumanDetail(){
            let res = await api.queryHumanDetail(this.$route.query.humanId);
            this.humanData = res.data.data;
            if(this.humanData.humanStatus == 0){
                this.stepsActive = 0;
                this.updateHumanStatus(10);

            }else if(this.humanData.humanStatus == 10){
                this.stepsActive = 1;
            }else if(this.humanData.humanStatus == 20){
                this.stepsActive = 2;
            }else if(this.humanData.humanStatus == 30){
                this.stepsActive = 3;
            }else if(this.humanData.humanStatus >= 40){
                this.stepsActive = 4;
            }
        },
        // tab切换
        // async tabSelect(e){
        //     console.log(e.index);
        //     if(e.index== 0){
        //     }else if(e.index==1){
                
        //     }else if(e.index==2){
        //     }else if(e.index==3){
        //     }else if(e.index==4){
        //     }
        // },
        submitCase(){
            if(this.stepsActive!=1&&this.stepsActive!=3){
                return;
            }
            if(this.tabsValue== 0){
                if(this.humanData.id){
                    this.updateHuman();
                }else{
                    this.addHuman();

                }
            }else if(this.tabsValue==1){
                this.saveDcTaskMaterials();
            }else if(this.tabsValue==2){
            }else if(this.tabsValue==3){
            }else if(this.tabsValue==4){
                // this.assignHuman();
            }else if(this.tabsValue==5){
            }
            
        },

        
        // 上传
        async materialUpload(file){
            console.log(file);
            let material = {
                humanId:this.$route.query.humanId,
                piccHumanId:this.$route.query.id,
                fileType:'',
                name:'',
                path:'',
            };
            material.name = file.file.name;
            let fileTypeList = material.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            material.fileType = fileType;
            let res = await api.uploadOtherSort(file.file);


            material.path = res;
            this.uploadImgList.push(material)
            // material.path = res;
            // if(this.materialList){
            //     this.materialList.push(material);
            // }else{
            //     this.materialList=[material];
            // }
        },
        // 删除资料
        clearMaterialList(index){
            this.materialList.splice(index,1)
        },
        download(path,name){
            this.$message({
                type: 'success',
                message: '下载成功,请稍等!'
            });
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },

        // 查询影像资料
        async queryDcTaskMaterialByPiccHumanId(){
            let res = await api.queryDcTaskMaterialByPiccHumanId(this.$route.query.id);
            this.materialList = res.data.data;
        },
        // 查询医院
        async queryHospitalByHumanId(){
            let res = await api.queryHospitalByHumanId(this.$route.query.humanId);
            this.hospitalList = res.data.data;
        },
        // 查询诊断信息
        // async queryHospitalByHumanId(){
        //     let res = await api.queryHospitalByHumanId(this.$route.query.id);
        //     this.hospitalList = res.data.data;
        // },
        // 选择标签
        selectTab(e){
            if(e.index==1){
                this.queryDcTaskMaterialByHumanId();
            }else if(e.index==2){
                this.queryHospitalByHumanId();
            }else if(e.index==3){
                this.queryZhenDuanInfoByHumanId();
            }else if(e.index==4){
                this.lossInfoList();
            }
            
        },
        // 添加医院信息
        async addHospital(){
            this.hospitalData.humanId = this.$route.query.humanId;
            this.hospitalData.piccHumanId = this.$route.query.id;
            let res = await api.HospitalAdd({
                hospitals:[this.hospitalData]
            });
            if(res.data.code == '200'){
                this.hospitalAddDialog = false;
                this.$message({
                    type: 'success',
                    message: '添加成功'
                });
                this.hospitalData = {
                    name:null,
                    keShi:null,
                    ruHospitalTime:null,
                    chuHospitalTime:null,
                    yjZhuHospitalTime:null,
                };
                this.queryHospitalByHumanId();
            }
        },
        // 查询诊断信息
        async queryZhenDuanInfoByHumanId(){
            let res = await api.queryZhenDuanInfoByHumanId(this.$route.query.humanId);
            this.diagnoseList = res.data.data;
        },
        // 添加诊断信息
        async addDiagnose(){
            this.diagnoseData.humanId = this.$route.query.humanId;
            this.diagnoseData.piccHumanId = this.$route.query.id;
            console.log(this.diagnoseData);
            let res = await api.AddZhenDuanInfo({
                zhenDuanInfos:[this.diagnoseData]
            });
            if(res.data.code == '200'){
                this.diagnoseDialog = false;
                this.$message({
                    type: 'success',
                    message: '添加成功'
                });
                this.diagnoseData = {
                    jws:null,
                    ssbw:null,
                    lczd:null,
                    ssms:null,
                    zsfs:null,
                };
                this.queryZhenDuanInfoByHumanId();
            }
        },

        // 查询定损信息
        async lossInfoList(){
            let res = await api.lossInfoList(this.$route.query.humanId);
            this.lossList = res.data.data;
        },
        // 添加定损信息
        async addLoss(){
            this.lossData.humanId = this.$route.query.humanId;
            this.lossData.piccHumanId = this.$route.query.id;
            this.lossData.spFee = parseFloat(this.lossData.spFee);
            this.lossData.dsFee = parseFloat(this.lossData.dsFee);
            this.lossData.hsFee = parseFloat(this.lossData.hsFee);
            console.log(this.lossData);
            let res = await api.lossInfoAdd({
                lossInfos:[this.lossData]
            });
            if(res.data.code == '200'){
                this.lossAddDialog = false;
                this.$message({
                    type: 'success',
                    message: '添加成功'
                });
                this.lossData = {
                    feeName:null,
                    spFee:null,
                    dsFee:null,
                    hsFee:null,
                };
                this.lossInfoList();
            }
        },

        // 修改操作人Id
        async changeOperatorId(e){
            for(let index in this.personList){
                if(this.personList[index].id==e){
                    this.humanData.operator =  this.personList[index].name;
                }
            }
        },
        // 修改调解人人Id
        async changeTjyId(e){
            for(let index in this.personList){
                if(this.personList[index].id==e){
                    this.humanData.tjy =  this.personList[index].name;
                }
            }
        },
        // 指派人员
        // async assignHuman(){
        //     console.log(this.humanData);
        //     let res = await api.assignHuman({
        //         "piccHumanTaskId": this.humanData.id,
        //         "piccHumanId": this.humanData.piccHumanId,
        //         "humanId": this.$route.query.humanId,
        //         "tjyId": this.humanData.tjyId,
        //         "tjy": this.humanData.tjy,
        //         "operatorId": this.humanData.operatorId,
        //         "operator": this.humanData.operator,
        //         "dcYq": this.humanData.dcYq,
        //     });
        //     if(res.data.code=='200'){
        //         this.updateHuman();
        //         this.$message({
        //             type: 'success',
        //             message: '修改成功'
        //         });
        //     }
        // },

        // 接受案件
        receiveCase(){
            this.$confirm('再次确认接受案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateHumanStatus(10);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async updateHumanStatus(status){
            let res = await api.updateHumanStatus({
                humanId:this.$route.query.humanId,
                humanStatus:status,
            });
            if(res.data.code=='200'){
                this.queryHumanDetail();
                if(status==20){
                    this.submitCase();
                }
            }
        },

        async submitAudit(){
            this.$confirm('再次确认提交案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateHumanStatus(20);
                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        closeViewer(){
            this.showBigImg = false;
        },

        materialDownload(){
            console.log(this.materialList);
            batchDownload(this.materialList)
        },   
        async downloadMaterial(){
            if(this.materialList.length==0){
                this.$message({
                    type: 'warning',
                    message: '没有资料下载！'
                });
                return;
            }
            let res = await api.downFileDcTaskMaterial(this.$route.query.humanId,this.detailData.caseNo);
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .top{
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding:10px;
        background-color: #ffffff;
        z-index: 60;
        /deep/.el-step__title{
           font-weight: bold; 
        }
        /deep/.el-steps--simple{
            padding: 13px 0px;
        }
    }
    .taskreason{
        span{
            color: red;
            font-size: 18px;
        }
        font-size: 14px;
        margin: 10px 0;
    }
    .index{
        .index-item{
            border: 1px solid #eee;
            box-shadow: 0 1px 4px rgbe(0,21,41,8%);
            display: flex;
            flex-wrap: wrap;
            padding:2px 15px;
            padding-top: 20px;
            margin-bottom: 10px;
            .title{
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 20px;
            }
            .content{
                min-width: 900px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .checkbox{
                    margin-right: 40px;
                    margin-bottom: 10px;
                    /deep/.el-checkbox__label{
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .citem{
                    display: flex;
                    align-items: center;
                    margin-right: 25px;
                    padding-bottom: 10px;
                    width: 380px;
                    .label{
                        width: 110px;
                        font-size: 15px;
                    }
                    .value{
                        border: 1px solid #DCDFE6;
                        border-radius: 4px;
                        font-size: 14px;
                        color: #606266;
                        line-height: 24px;
                        padding: 5px 10px;
                    }
                    .citem-input{
                        width: 250px;
                    }
                    /deep/.el-tag--medium{
                        height: 42px;
                        line-height: 42px;
                        margin-right: 10px;
                    }
                }
            }
            
        }
        .card{
            .content{
                min-width: 900px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .checkbox{
                    margin-right: 40px;
                    margin-bottom: 10px;
                    /deep/.el-checkbox__label{
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .citem{
                    display: flex;
                    align-items: center;
                    margin-right: 25px;
                    padding-bottom: 10px;
                    width: 380px;
                    .label{
                        width: 125px;
                    }
                    .citem-input{
                        width: 250px;
                    }
                    /deep/.el-tag--medium{
                        height: 42px;
                        line-height: 42px;
                        margin-right: 10px;
                    }
                }
                .citem-textarea{
                    width: 100%;
                    .label{
                        width: 150px;
                    }
                    .citem-input{
                        width: 750px;
                    }
                }
            }

            .materiallist{
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 15px;
                align-items: center;
                .material{
                    border: 1px dashed #dcdcdc;
                    width: 150px;
                    padding-top: 15px;
                    padding-bottom: 6px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    border-radius: 4px;
                    margin:10px;
                    position: relative;
                    float: left;
                    span{
                        display: flex;
                        flex-wrap: wrap;
                    }
                    img{
                        width: 120px;
                    }
                    .close{
                        width: 25px;
                        height: 25px;
                        position: absolute;
                        right: 3px;
                        top: 3px;
                    }
                    .filename{
                        width: 130px;
                        font-size: 12px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        margin-top: 2px;
                    }
                    .el-button--mini, .el-button--mini.is-round{
                        padding-bottom: 0px;
                        padding-top: 4px;
                    }
                }
            }
            .btns{
                margin-bottom: 15px;
                display: flex;
            }
        }
        .bottom{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }


        .dialog{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                }
                .item-input{
                    width: 340px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/.el-input{
                        width: 320px;
                    }
                }
                .item-imgs{
                    width: 380px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
                .item-textarea{
                    width: 380px;
                }
            }


            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
            
        }
        .dialog-t{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                }
                .item-input{
                    width: 340px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/.el-input{
                        width: 320px;
                    }
                }
                .item-imgs{
                    width: 380px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
                .item-textarea{
                    width: 380px;
                }
            }
            .section{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                border: 1px solid #DEDEDE;
                margin-bottom: 15px;
                padding-bottom: 10px;
                .title{
                    width: 100%;
                    font-weight: bold;
                    font-size: 16px;
                    margin-bottom: 12px;
                    background-color: #DEDEDE;
                    padding:8px 15px;
                }
                .materiallist{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    margin-bottom: 15px;
                    padding: 15px;
                    .material{
                        border: 1px dashed #dcdcdc;
                        width: 150px;
                        height: 170px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        border-radius: 4px;
                        margin:10px;
                        position: relative;
                        img{
                            width: 120px;
                        }
                        .close{
                            width: 25px;
                            height: 25px;
                            position: absolute;
                            right: 3px;
                            top: 3px;
                        }
                        .filename{
                            width: 130px;
                            font-size: 12px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: center;
                            margin-top: 2px;
                        }
                    }
                }
            }
            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
        }
    }

    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding-bottom: 15px;
        
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            width: 300px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }

    .section{
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
        }
        .title-s{
            display: flex;
            justify-content: space-between;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
                display: flex;
                align-items: center;
                .dot{
                    color: red;
                    font-size: 20px;
                }
            }
            .value{
                width: 220px;
                .value-textarea{
                    border:1px solid #DCDFE6;
                    width: 564px;
                    min-height: 50px;
                    border-radius: 4px;
                    padding: 5px 14px;
                    font-size: 13px;
                    line-height: 24px;
                }
            }
           
        }
    
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 16px;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
</style>
